function PuzzleIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          d='M5.5 8.78777V30H26.5V22.7882C25.7981 23.3207 24.9255 23.6364 23.98 23.6364C21.6605 23.6364 19.78 21.7369 19.78 19.3939C19.78 17.0509 21.6605 15.1515 23.98 15.1515C24.9255 15.1515 25.7982 15.4672 26.5 15.9997V8.78787H19.3603C19.8875 8.07884 20.2001 7.19746 20.2001 6.24245C20.2001 3.89945 18.3196 2 16.0001 2C13.6805 2 11.8001 3.89945 11.8001 6.24245C11.8001 7.19746 12.1126 8.07895 12.6398 8.78787H5.5V8.78777Z'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
          stroke='currentColor'
        />
      </svg>
    </span>
  );
}

export default PuzzleIcon;
